import { eTipoPermissao } from '@/enums/ePermissoes';

// Painel "PDI Pendente" — alunos inclusivos (PCD/Hipótese) SEM PDI (raiz PDIAluno) no ano, com a
// ação "Criar PDI" que abre o workspace da anamnese do estudante. Menu próprio (permissão
// NOVO_PDI_PENDENTE_2300100152). Reusa a lista inclusiva (flag somentePendentes) e o workspace da
// anamnese (módulo pdi-anamnese).
export default [
  {
    description: 'Estudantes sem {pdiSigla}',
    path: '/educacaoinclusiva/pdi-pendente',
    name: 'pdi_pendente',
    component: () => import('@/views/educacaoinclusiva/pdi-pendente/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.NOVO_PDI_PENDENTE_2300100152],
    },
    goesToMenu: true,
  },
];
